"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var imagery_sand_box_module_1 = require("./imagery-sand-box.module");
exports.ImagerySandBoxModule = imagery_sand_box_module_1.ImagerySandBoxModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/imagerySandBox/index.js
// module id = ../../../../../src/app/packages/menu-items/imagerySandBox/index.js
// module chunks = main